import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'cursor-events',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'cursor.event.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 700,
          },
        ],
      },
    },
    description: 'Browse all recorded Cursor usage events.',
    name: 'Cursor Events',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
